import React, { useEffect, useState } from "react";
import { MDBCol, MDBContainer, MDBRow, MDBSpinner } from "mdb-react-ui-kit";
import Alert from "react-bootstrap/Alert";

import "./MainPage.css";
import config from "../config.json";

import CategoryCard from "../components/Cards/CategoryCard";
import EmployeeCard from "../components/Cards/EmployeeCard";
import ListSearchCard from "../components/Cards/ListSearchCard";
import ChartCard from "../components/Cards/ChartCard";
import HeaderCard from "../components/Cards/HeaderCard";
import MainInfoCard from "../components/Cards/MainInfoCard";

function EntityDetails({ entityID, sidebarDiv, setSidebarDiv }) {
  const [entityData, setEntityData] = useState("");
  const [entityCategories, setEntityCategories] = useState("");
  const [entityTraining, setEntityTraining] = useState("");
  const [employeeData, setEmployeeData] = useState("");
  const [allEmpData, setAllEmpData] = useState("");
  const [employeeKSA, setEmployeeKSA] = useState("");
  const [employeeQuery, setEmployeeQuery] = useState("");
  const [showSuggestionsFlag, setShowSuggestionsFlag] = useState(false);
  const [showEmployeeData, setShowEmployeeData] = useState(false);
  const [invalidInputAlert, setInvalidInputAlert] = useState(false);

  useEffect(() => {
    (async () => {
      const response = await fetch(
        config.domainName + ":" + config.port + "/api/entityquery",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            function: "AllEntityData",
            entity_id: entityID,
          }),
        }
      );

      const response2 = await fetch(
        config.domainName + ":" + config.port + "/api/entityquery",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            function: "FunctionCategory",
            entity_id: entityID,
          }),
        }
      );

      const response3 = await fetch(
        config.domainName + ":" + config.port + "/api/entityquery",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            function: "EntityTrainingNeeds",
            entity_id: entityID,
          }),
        }
      );

      const content = await response.json();
      const content2 = await response2.json();
      const content3 = await response3.json();

      setEntityData(content);
      setEntityCategories(content2["function categories"]);
      setEntityTraining(content3["Unique Training Courses"]);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const response = await fetch(
        config.domainName + ":" + config.port + "/api/employee",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            entity_id: entityID,
          }),
        }
      );

      const content = await response.json();
      setEmployeeData(content.employee);
    })();
  }, []);

  const selectEmployee = async (e) => {
    e.preventDefault();
    const employee = employeeData.find(
      (item) => item["employee id"] === employeeQuery
    );
    if (!employee) {
      // employeeQuery is not found within employeeData
      setInvalidInputAlert(true);
      setSidebarDiv(false);
      return;
    }

    setInvalidInputAlert(false);

    const response = await fetch(
      config.domainName + ":" + config.port + "/api/employeequery",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          function: "AllEmployeeData",
          employee_id: employeeQuery,
        }),
      }
    );

    const response2 = await fetch(
      config.domainName + ":" + config.port + "/api/employeequery",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          function: "EmployeeKSA",
          employee_id: employeeQuery,
        }),
      }
    );

    const content = await response.json();
    const content2 = await response2.json();

    setAllEmpData(content);
    setEmployeeKSA(content2["user ksa"]);
    setShowEmployeeData(true);
    setSidebarDiv(true);
  };

  const suggestionToQuery = (newQueryname, newQueryID) => {
    document.getElementById("empName").value = newQueryname;
    setEmployeeQuery(newQueryID);
  };

  const clearEmployeeQuery = (clearing) => {
    if (clearing) {
      document.getElementById("empName").value = "";
      setInvalidInputAlert(false);
      setSidebarDiv(false);
    }
    setEmployeeQuery("");
    setAllEmpData("");
    setEmployeeKSA("");

    document.getElementById("empName").disabled = false;
  };

  return (
    <div className="bg-image">
      {entityData !== "" ? (
        <div id="home">
          <HeaderCard entityData={entityData} isEntity={true} />

          <div className="mainPageDiv">
            <MDBRow className="row-cols-1 row-col-md-12 g-4 d-flex justify-content-center">
              <MDBCol id="title">
                <MainInfoCard
                  isHeader={true}
                  isEntity={true}
                  logoImg={`/entity logos/logo-${entityData["entity"]["entity id"]}.png`}
                  col1Num={entityData["entity"]["number of employees"]}
                  overallGrade={String(entityData["entity grade"])}
                  overallGradeImg={`/grades/grade-${entityData["entity grade"]}-hollow.png`}
                  overallScore={String(entityData["entity score"])}
                  overallScoreColor={entityData["color"]}
                />
                {/* <EntityCard entityData={entityData} header={true} /> */}
              </MDBCol>
              <MDBCol id="table">
                <CategoryCard
                  tableCategories={entityCategories}
                  heading={"Employee Category Evaluation Level Per Entity"}
                />
              </MDBCol>

              <MDBCol id="recommend">
                <ChartCard
                  title={"Recommended Training"}
                  errorMessage={
                    "Recommended training chart data could not be found"
                  }
                  chartInputData={entityTraining}
                />
                {/* <ListCard title={"Recommended Training"} /> */}
              </MDBCol>

              <MDBCol className="m-5" id="empSearch">
                <ListSearchCard
                  title="Employee Details"
                  setEmployeeQuery={setEmployeeQuery}
                  employeeQuery={employeeQuery}
                  setShowSuggestionsFlag={setShowSuggestionsFlag}
                  showSuggestionsFlag={showSuggestionsFlag}
                  employeeData={employeeData}
                  selectEmployee={selectEmployee}
                  suggestionToQuery={suggestionToQuery}
                  clearEmployeeQuery={clearEmployeeQuery}
                />
              </MDBCol>
              {invalidInputAlert && (
                <Alert variant="danger">
                  Invalid Input - This is not a valid input for an Employee
                  Name. Please try again
                </Alert>
              )}
              {showEmployeeData && (
                <MDBCol className="m-5" id="empDetails">
                  <EmployeeCard
                    employeeData={allEmpData}
                    ksaData={employeeKSA}
                  />
                </MDBCol>
              )}
            </MDBRow>
          </div>
        </div>
      ) : (
        <MDBContainer
          fluid
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <MDBSpinner
            color="primary"
            className="me-2"
            style={{ width: "5rem", height: "5rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </MDBSpinner>
        </MDBContainer>
      )}
    </div>
  );
}
export default EntityDetails;
